module.exports = __webpack_public_path__ + "static/media/hero-gh.f7d82020.jpg";